import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { TranslationConfigService } from '@services';
import { ActiveErrorData } from '@store';

@Injectable({
  providedIn: 'root',
})
export class ActiveErrorsService {
  readonly defaultLangCode = 'en';
  readonly defaultCountryCode = 'GB';

  sourcedActiveErrors: ActiveErrorData[] = [];
  activeErrors$: BehaviorSubject<ActiveErrorData[]> = new BehaviorSubject<ActiveErrorData[]>([]);

  constructor(private translationConfig: TranslationConfigService) {}

  getSearchActiveErrorParameters(
    boilerSerial: string
  ): { serial: string; countryCode: string; langCode: string } {
    const serial = (boilerSerial || '').slice(0, 7);
    const lang = this.translationConfig.getLanguage();
    const langCode = lang ? lang.split('-')[0] : this.defaultLangCode;
    const countryCode = lang ? lang.split('-')[1] : this.defaultCountryCode;

    return { serial, countryCode, langCode };
  }
}
